/**  Mostly copied from old component AgentSection changed to use new components */

import React, { useContext } from 'react';
import styled from 'styled-components';
import { Text, Color } from '@brokerbay/elements-web';

import { Contact } from 'components';
import { BrokerageInfo } from 'components/UniversalSearch/components';
import Section from '../Section';
import InfoContainer from '../InfoContainer';
import ShowingDetailsContext from '../../ShowingDetailsV2/ShowingDetailsContext';

const AgentOrgSection: React.FC = () => {
  const {
    listing: { reps, org },
    fromTourPage,
    tourFunctions,
  } = useContext(ShowingDetailsContext);
  if ((!reps || reps.length === 0) && !org) return null;
  const handleClickToCloseModal = () => {
    if (fromTourPage && tourFunctions) {
      tourFunctions.closeAppointmentModal();
    }
  };
  return (
    <Section title="Agent">
      {reps?.length && (
        <InfoContainer
          icon="userRectangle"
          iconPaddingTop={12}
          colorName="grey"
        >
          {reps.map(rep => (
            <div key={rep.id} onClick={handleClickToCloseModal}>
              <Contact
                key={rep.id}
                contact={{ ...rep }}
                avatarSize={32}
                secondaryText={<StyledText size="small">Broker</StyledText>}
              />
            </div>
          ))}
        </InfoContainer>
      )}
      {org && (
        <InfoContainer icon="building" iconPaddingTop={6} colorName="grey">
          <BrokerageInfo orgName={org.name} orgLogoUrl={org.logoUrl} />
        </InfoContainer>
      )}
    </Section>
  );
};

export default AgentOrgSection;

const StyledText = styled(Text)`
  color: ${Color.SUVA_GREY};
  text-align: start;
`;
